module.exports = __webpack_public_path__ + "img/icon_agent_en.435c9c07.png";